import React, { Component } from 'react';
import ModalWrapper from './ModalWrapper';
import { withTranslation } from 'react-i18next';
class OperatorModal extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            show:true
         }
    }
    setModalView=()=>{
        this.setState({
            show:false
        })
    }
    render() { 
        const {t} = this.props
        return ( 
            <ModalWrapper show={ this.props.show}>
                <div 
                    className="p-4 bg-light mx-auto text-center py-md-5 py-4" 
                    style={{width:'40rem'}}> 
                    <span>{t(this.props.msg)}</span>
                    <br/>
                    <button 
                        className="btn  border-color-blue mt-3 mx-2"
                        onClick={()=>{this.props.close(false)}}>
                        <span className="fw-bold color-blue">{t("Close")}</span>
                    </button>
                </div>
            </ModalWrapper>
         );
    }
}
 
export default (withTranslation()  (OperatorModal));